import $ from "jquery";

/* eslint-disable */
const filtersDropdown = $(".filters-dropdown"),
  dropdownItem = $(".dropdown-item label"),
  preloader = $(".gallery-list-preloader"),
  typeItem = $(".product-types-wrapper .type label"),
  filterForm = $("#gallery__filters-form"),
  galleryListWrapper = $(".gallery-list-wrapper .container"),
  galleryCheckbox = $(".filter-form__checkbox"),
  galleryCheckboxDrop = $(".filter-form__checkbox-drop"),
  galleryPopup = $(".gallery-popup");

filtersDropdown.on("click", function () {
  if (!$(this).closest(".filters-dropdown").hasClass("expanded")) {
    $(".filters-dropdown.expanded").removeClass("expanded");
    $(this).closest(".filters-dropdown").addClass("expanded");
  } else {
    $(this).closest(".filters-dropdown").removeClass("expanded");
  }
});

typeItem.on("click", function () {
  $(".product-types-wrapper .type").removeClass("active");
  $(this).parent().addClass("active");
});

dropdownItem.on("click", function () {
  $(this).parent().parent().find(".dropdown-item").removeClass("active");
  $(this).closest(".filters-dropdown").toggleClass("expanded");
  $(this).parent().addClass("active");
});

$(window).on("resize", function () {
  filtersDropdown.removeClass("expanded");
});

function galleryFilterSubmit() {
  let galleryFilterData = filterForm.serialize();
  $.ajax({
    type: "POST",
    url: themeVars.ajaxUrl,
    data: {
      action: "galleryLoad",
      data: galleryFilterData,
      paged: galleryVars.currentPage,
    },
    beforeSend: function () {
      preloader.fadeIn();
    },
    success: function (response) {
      let parsedResponse = JSON.parse(response);
      galleryVars.posts = parsedResponse.posts;
      galleryVars.maxPage = parsedResponse.maxPage;
      galleryVars.currentPage = parsedResponse.currentPage;
      galleryVars.foundPosts = parsedResponse.foundPosts;
      galleryVars.resourcesSearch = parsedResponse.resourcesSearch;
      galleryListWrapper.fadeOut(function () {
        preloader.fadeOut();
        galleryListWrapper.html(parsedResponse.content);
        galleryListWrapper.fadeIn(1000);
      });
    },
  });
}

galleryCheckboxDrop.on("change", function () {
  $(".product-types-wrapper .type.active")
    .removeClass("active")
    .prop("checked", false);
  $("#type-all").parent().addClass("active").prop("checked", true);
  galleryFilterSubmit();
});

galleryCheckbox.on("change", function () {
  galleryFilterSubmit();
});

$(document).on("click", ".gallery-list-wrapper .gallery-item", function (e) {
  let imageSrc = $(this).find("img").attr("src");
  let itemData = $(this).data();
  $.each(itemData, function (key, value) {
    let itemFeature = $(`.data-${key}`);
    itemFeature.html(value);
    itemFeature.parents(".feature").show().css("display", "flex");
  });
  galleryPopup.find("img").attr("src", imageSrc);
  galleryPopup.fadeIn().addClass("opened");
});

$(document).on("click", ".gallery-popup-wrapper .close", function () {
  galleryPopup.fadeOut().removeClass("opened");
  $("body").removeClass("fixed");
  galleryPopup.find(".feature").fadeOut();
  galleryPopup.find("img").attr("src", "");
});

galleryPopup.on("click", function (e) {
  if ($(e.target).is(this)) {
    galleryPopup.fadeOut().removeClass("opened");
    $("body").removeClass("fixed");
    galleryPopup.find(".feature").fadeOut();
    galleryPopup.find("img").attr("src", "");
  }
});

$(document).on("click", ".gallery-list-wrapper .page-numbers", function (e) {
  e.preventDefault();
  const clicked_url = $(this).attr("href");
  const page = clicked_url.match(/\/page\/(\d*)/);
  let clicked_page = page !== null ? page[1] : 1;
  clicked_page = parseInt(clicked_page, 10);

  $.ajax({
    type: "POST",
    url: themeVars.ajaxUrl,
    data: {
      action: "paginationGalleryAjaxHandler",
      query: galleryVars.posts,
      page: clicked_page,
    },
    beforeSend: function () {
      preloader.fadeIn();
    },
    success: function (response) {
      preloader.fadeOut();
      if (response) {
        response = $(response).hide().fadeIn();
        galleryListWrapper.html(response);
        galleryVars.currentPage = clicked_page;
      }
    },
  });
});

//trigger if URL has get parameter
$(document).ready(function () {
  let urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("type")) {
    let productTypeValue = urlParams.getAll("type");
    productTypeValue.forEach((e) => {
      let $this = $('.filter-form__checkbox[value="' + e + '"]');
      $this.prop("checked", true);
      $(".type").removeClass("active");
      $this.parent().addClass("active");
    });
  }
  if (urlParams.has("opening")) {
    let openingTypeValue = urlParams.getAll("opening");
    openingTypeValue.forEach((e) => {
      let $this = $(
        '.opening-types .filter-form__checkbox-drop[value="' + e + '"]'
      );
      $this.prop("checked", true);
      $this.parent().parent().find(".dropdown-item").removeClass("active");
      $this.parent().addClass("active");
    });
  }
  if (urlParams.has("colour")) {
    let productColorValue = urlParams.getAll("colour");
    productColorValue.forEach((e) => {
      let $this = $(
        '.product-colours .filter-form__checkbox-drop[value="' + e + '"]'
      );
      $this.prop("checked", true);
      $this.parent().parent().find(".dropdown-item").removeClass("active");
      $this.parent().addClass("active");
    });
  }
  if (
    urlParams.has("type") ||
    urlParams.has("opening") ||
    urlParams.has("colour")
  ) {
    galleryFilterSubmit();
  }
});

